import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row gap-10" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center mb-4" }
const _hoisted_3 = {
  key: 0,
  class: "list-group mb-10"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("li", {
  class: "list-group-item active",
  "aria-current": "true"
}, "Varones", -1)
const _hoisted_5 = { class: "d-flex justify-content-between" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "list-group-item"
}
const _hoisted_8 = {
  key: 1,
  class: "list-group mb-10"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", {
  class: "list-group-item active",
  "aria-current": "true"
}, "Varones", -1)
const _hoisted_10 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_11 = { class: "p-4" }
const _hoisted_12 = { class: "d-flex flex-column w-100" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 2,
  class: "list-group"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("li", {
  class: "list-group-item bg-danger text-white",
  "aria-current": "true"
}, "Damas", -1)
const _hoisted_16 = { class: "d-flex justify-content-between" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 1,
  class: "list-group-item"
}
const _hoisted_19 = {
  key: 3,
  class: "list-group mb-10"
}
const _hoisted_20 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_21 = { class: "p-4" }
const _hoisted_22 = { class: "d-flex flex-column w-100" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_25 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_26 = {
  key: 1,
  class: "div"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", null, "Atleta 1", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", null, "Atleta 2", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      title: _ctx.titleDialog,
      modelValue: _ctx.isModalVisible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isModalVisible) = $event)),
      class: "bg-light rounded",
      "close-on-click-modal": false,
      draggable: "",
      "destroy-on-close": "",
      top: "2vh",
      fullscreen: true,
      onOpen: _ctx.onOpen
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listModalidades, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col",
              key: index
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("h1", null, _toDisplayString(item.name), 1),
                (_ctx.closure?.mstatus == 'O')
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      onClick: ($event: any) => (_ctx.addPrueba(item)),
                      type: "success"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Agregar")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              (item?.men)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                    _hoisted_4,
                    (item.men.length>0)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item?.men, (atleta, indx) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: "list-group-item",
                            key: `itmm-${indx}`
                          }, [
                            _createElementVNode("div", _hoisted_5, [
                              _createTextVNode(_toDisplayString(atleta?.person) + " ", 1),
                              (_ctx.closure?.mstatus == 'O')
                                ? (_openBlock(), _createElementBlock("i", {
                                    key: 0,
                                    class: "bi bi-trash fs-2 cursor-pointer text-hover-danger",
                                    onClick: ($event: any) => (_ctx.deleteTest(atleta?.id)),
                                    title: "Eliminar"
                                  }, null, 8, _hoisted_6))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      : (_openBlock(), _createElementBlock("li", _hoisted_7, "No tiene información asignada"))
                  ]))
                : _createCommentVNode("", true),
              (item?.doblem)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                    _hoisted_9,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item?.doblem, (itemdoble, indx) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "list-group-item",
                        key: `itmm-${indx}`
                      }, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("span", _hoisted_11, _toDisplayString(itemdoble?.couple), 1),
                          _createElementVNode("div", _hoisted_12, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemdoble?.lista, (atle, inx) => {
                              return (_openBlock(), _createElementBlock("span", {
                                class: "border bg-secondary",
                                key: `mjgk-${inx}`
                              }, _toDisplayString(atle?.person), 1))
                            }), 128))
                          ]),
                          (_ctx.closure?.mstatus == 'O')
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 0,
                                class: "bi bi-trash fs-2 cursor-pointer text-hover-danger",
                                onClick: ($event: any) => (_ctx.deleteDouble(item.code, 'M', itemdoble)),
                                title: "Eliminar"
                              }, null, 8, _hoisted_13))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (item?.women)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [
                    _hoisted_15,
                    (item.women.length>0)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item?.women, (atleta, indx) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: "list-group-item",
                            key: `itmw-${indx}`
                          }, [
                            _createElementVNode("div", _hoisted_16, [
                              _createTextVNode(_toDisplayString(atleta?.person) + " ", 1),
                              (_ctx.closure?.mstatus == 'O')
                                ? (_openBlock(), _createElementBlock("i", {
                                    key: 0,
                                    class: "bi bi-trash fs-2 cursor-pointer text-hover-danger",
                                    onClick: ($event: any) => (_ctx.deleteTest(atleta?.id)),
                                    title: "Eliminar"
                                  }, null, 8, _hoisted_17))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      : (_openBlock(), _createElementBlock("li", _hoisted_18, "No tiene información asignada"))
                  ]))
                : _createCommentVNode("", true),
              (item?.doblew)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_19, [
                    _createElementVNode("li", {
                      class: _normalizeClass(`list-group-item bg-${item?.code == 'PB0253' ? 'info' : 'danger'} text-white`),
                      "aria-current": "true"
                    }, _toDisplayString(item?.code == 'PB0253' ? 'Participantes' : 'Damas'), 3),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item?.doblew, (itemdoble, indx) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "list-group-item",
                        key: `itmm-${indx}`
                      }, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("span", _hoisted_21, _toDisplayString(itemdoble?.couple), 1),
                          _createElementVNode("div", _hoisted_22, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemdoble?.lista, (atle, inx) => {
                              return (_openBlock(), _createElementBlock("span", {
                                class: "border bg-secondary",
                                key: `mjgk-${inx}`
                              }, _toDisplayString(atle?.person), 1))
                            }), 128))
                          ]),
                          (_ctx.closure?.mstatus == 'O')
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 0,
                                class: "bi bi-trash fs-2 cursor-pointer text-hover-danger",
                                onClick: ($event: any) => (_ctx.deleteDouble(item.code, 'F', itemdoble)),
                                title: "Eliminar"
                              }, null, 8, _hoisted_23))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])), [
          [_directive_loading, _ctx.loading]
        ])
      ]),
      _: 1
    }, 8, ["title", "modelValue", "onOpen"]),
    _createVNode(_component_el_dialog, {
      title: `Seleccione para ${_ctx.getTest.name}`,
      modelValue: _ctx.isModalSelection,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isModalSelection) = $event)),
      width: "600",
      onClosed: _ctx.onClosed
    }, {
      default: _withCtx(() => [
        (_ctx.getTest.code == 'PB0163' || _ctx.getTest.code == 'PB0165')
          ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              key: 0,
              data: _ctx.listNominal,
              height: "500"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "persona",
                  label: "PARTICIPANTE"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "gender",
                  label: "SEXO",
                  width: "80"
                }, {
                  default: _withCtx(({row}) => [
                    (row.gender == 'M')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(row.gender), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(row.gender), 1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "OPCION",
                  width: "120"
                }, {
                  default: _withCtx(({row}) => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small",
                      onClick: ($event: any) => (_ctx.guardarSeleccion(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("seleccionar")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, _ctx.loadingSelection]
            ])
          : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_26, [
              _hoisted_27,
              _createVNode(_component_el_select, {
                modelValue: _ctx.atleta1,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.atleta1) = $event)),
                "value-key": "idacreditation",
                placeholder: "Seleccione atleta 1",
                filterable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listNominal, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.idacreditation,
                      label: item.persona,
                      value: item
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _hoisted_28,
              _hoisted_29,
              _createVNode(_component_el_select, {
                modelValue: _ctx.atleta2,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.atleta2) = $event)),
                "value-key": "idacreditation",
                placeholder: "Seleccione atleta 2",
                filterable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listNominal, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.idacreditation,
                      label: item.persona,
                      value: item
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_button, {
                onClick: _ctx.guardarDoble,
                class: "mt-5",
                type: "success"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Guardar seleccion")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])), [
              [_directive_loading, _ctx.loadingSelection]
            ])
      ]),
      _: 1
    }, 8, ["title", "modelValue", "onClosed"])
  ], 64))
}